// Names from
// http://www.iabstandards.be/#/
export const HALF_PAGE_SKYSCRAPER = [300, 600];
export const LEADERBOARD = [728, 90];
export const MEDIUM_RECTANGLE = [300, 250];
export const TINY_RECTANGLE = [320, 50];
export const TINY_RECTANGLE_2 = [300, 50];

// Names from https://pubguide.jumpstartauto.net/docs/ad-tag-taxonomy-and-logic
export const SHOPPING_LINKS = [400, 40];

export default {
  HALF_PAGE_SKYSCRAPER,
  SHOPPING_LINKS,
  LEADERBOARD,
  MEDIUM_RECTANGLE,
  TINY_RECTANGLE,
};
